import { getVehicleFilterCollectionV2, SearchVehicleFilterApiParameter } from "@dana/Services/VehicleFilterService";
import { WishlistAvailabilityActions } from "@dana/Store/Data/WishlistAvailability/Reducers/WishlistAvailabilityReducer";
import {
    createHandlerChainRunner,
    Handler,
    HandlerProps
} from "@insite/client-framework/HandlerCreator";
import { WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{},
    DispatchProp<WishlistAvailabilityActions>
>;
export const ClearAvailabilityPopup: HandlerType = props => {
    props.dispatch?.({
        type: "WishlistAvailability/Init",
    });
    props.dispatch?.({
        type: "WishlistAvailability/IsLoading",
        isLoading: true,
    });
    props.dispatch?.({
        type: "WishlistAvailability/SetWishlist",
        wishList: null,
        wishListLineCollection: null,
    });
}

export const chain = [
    ClearAvailabilityPopup,
];

const resetWishlistavAilability = createHandlerChainRunner(chain, "ResetWishlistavAilability");
export default resetWishlistavAilability;
